import { z } from 'zod';

export const donationDetailsMicrositeSchema = z.object({
    ddRelationshipToPatient: z.string().min(1, 'Required'),
});
